<template>
  <div class="conference_box">
    <div class="calls_title">{{ type == 0 ? lang.call_in_progress : lang.conference_call }}</div>
    <div class="calls_list">
      <div class="calls_list_item" v-for="(call, idx) in callsList" :key="idx">
      <!-- <div class="calls_list_item"> -->
        <div class="call_info">
          <div class="avatar"></div>
          <!-- <div class="num">0804847463</div> -->
          <div class="num">{{ call.to }}</div>
        </div>
        <div class="call_btns">
          <div class="btn_item" v-if="type == 0" @click="$emit('conferFun', type, true)">
            {{ lang.join_conference_call }}
          </div>
          <div class="btn_item cancel" @click="$emit('conferFun', type, false)">
            <font-awesome-icon :icon="['fas', 'phone']" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "conference",
    props: ["callsList", "lang", "type"],
    methods: {}
  }
</script>

<style lang="scss" scoped>
.conference_box {
  padding: 10px 0;
  .calls_title{
    padding: 5px 0;
    font-size: 18px;
    border-bottom: 1px solid #4DB1EC;
    font-weight: bold;
  }
  .calls_list{
    .calls_list_item {
      background: #eff5f8;
      padding: 10px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      min-height: 60px;
      .call_info, .call_btns {
        display: flex;
        align-items: center;
        justify-content: space-around;
      }
      .call_info{
        .num{
          font-weight: bold;
        }
      }
      .call_btns{
        .btn_item {
          margin: 0 10px;
          cursor: pointer;
          &.answer{
            color: #5D9048;
          }
          &.cancel{
            transform: rotateZ(135deg);
            color: #c80000;
          }
        }
      }

    }
  }
}
</style>
